import ReactHtmlParser from 'react-html-parser';
import { confirmAlert } from 'react-confirm-alert'; 
import HmEventRegistry from './../../model/HmEventRegistry';
import RbUtil from './../../util/RbUtil';


/****
ERRERROR_PROMPT - obj structure 
{
  "title": "title to be shown - text in rb | defaults to 500.title then Alert",
  "msg" : "Message to be loaded - text in rb",
  "status_code":"Error code : defaults to 500 ",
  "url" : "Optional: url to be shown unaccessible",
  "buttons":[
  "label":"buttons array is optional - label - button's label - from rb",
  "handler":"type: function - to be executed"
  ]
}
***/
/****
ERRERROR_PROMPT - Copy to add inputs 
{
  "title": "",
  "msg" : "",
  "status_code":500,
  "url" : null
}
***/

const rb = function(rawTxt,replaceStringArray=[]){
    return RbUtil.getText(rawTxt,replaceStringArray);
}

const ErrorPrompt = function(obj){
  

  var title = rb("500.title");
  var msg = "";
  var btnHandlers = (obj && obj.buttons) ? obj.buttons : null;

  try{
   title = rb(obj.title);
 }catch(e){}

 try{
  if(obj.reference_id){
    msg += rb("500.reference_id").replace("{#reference_id}", obj.reference_id);
  }

  if(obj.url){
    let matcher = obj.url.match("http(s)?://([^/]+)/");
    if(matcher && matcher.length > 0){
      let uri = obj.url.replace(matcher[0], "").replace(/\//g,"-");
      msg += rb("500.url").replace("{#url}",uri);
    }  
  }

  if(obj.msg){
    msg += rb(obj.msg);
  }else if(obj.message){
   msg += rb(obj.message);
 }

}catch(e){

}

var errObj = {
  "error_id" : obj.reference_id,
  "status_code": obj.status_code || 500,
  "url":obj.url || "",
  "enum_key":"source",
    "enum_replace_key":"encounteredErrorSource",
    "enum_replace_value":obj.server_src || "um"
};


HmEventRegistry.fireEvent("TRACK_EVENT","error_encountered",errObj);


this.show = function(){
  var me = this;

  var buttons = [];

  try{
    if(btnHandlers !== undefined && btnHandlers !== null && btnHandlers.length > 0){
      for(var i=0;i<btnHandlers.length; i++){
        buttons.push({
          label: btnHandlers[i].label || me.rb("btn.ok"),
          onClick: (typeof btnHandlers[i].handler === "function") ? btnHandlers[i].handler : () => {}
        })
      }
    }
  }catch(e){}

  if(buttons.length == 0){
    buttons.push({
      label: 'Ok',
      onClick: () => {}
    });
  }

  return confirmAlert({
    title: title || 'Alert',
    message:  msg ? ReactHtmlParser( msg) : 'Hello..',
    buttons: buttons
  }); 
}
}

const AlertPrompt = function(msg,title=null){
  return confirmAlert({
    title: rb(title|| 'Alert'),
    message:  msg ? ReactHtmlParser(rb(msg)) : '',
    buttons: [{
      label: 'Ok',
      onClick: () => {

      }
    }]
  }); 
}

HmEventRegistry.registerEvent("ERROR_PROMPT",function(obj){
  new ErrorPrompt(obj).show();
});

HmEventRegistry.registerEvent("INVALID_PROMPT_PROMPT",function(obj){
  obj["title"] = rb(obj.title);
  obj["msg"] = rb(obj.msg);

  var constestsLink = "";
  if(obj.available_contests && obj.available_contests.length > 0){
     obj.available_contests.map((each, idx) => {
       if(each){
         constestsLink += "<a href=/"+each+">"+rb("title."+each.toLowerCase())+"</a>";
         constestsLink += ","
       }        
     });

     constestsLink = constestsLink.substring(0,constestsLink.length-1);
  }
  obj["msg"] = obj["msg"].replace("{#available_contests}",constestsLink);

  new ErrorPrompt(obj).show();
});


window.showError = (msg,title=null) => {
  new AlertPrompt(msg,title);
}


// WEBPACK FOOTER //
// ./src/views/core/ErrorPrompt.js